import React from "react";
import ReactDOM from 'react-dom';
import App from "./App";
import "./styles/styles.css";
import 'regenerator-runtime/runtime';

ReactDOM.render(
    <App />, document.getElementById('root')
);